class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  connectedCallback() {
    this.header = this.closest('.header-wrapper');
    this.hoverQuery = window.matchMedia('(min-width: 990px) and (any-hover: hover) and (any-pointer: fine)');
    this.hoverMenus = Array.from(this.querySelectorAll('details'), (details) => {
      const menu = { details, summary: details.querySelector('summary'), inside: false };
      menu.enter = (event) => this.onHoverEnter(menu, event);
      menu.leave = (event) => this.onHoverLeave(menu, event);
      menu.sync = () => menu.summary.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('pointerenter', menu.enter);
      details.addEventListener('pointerleave', menu.leave);
      details.addEventListener('toggle', menu.sync);
      menu.sync();
      return menu;
    });
    this.onHoverModeChange = () => {
      if (!this.hoverQuery.matches) this.close();
    };
    this.onHoverKeyUp = (event) => {
      if (event.code === 'Escape') this.clearHoverTimers();
    };
    this.hoverQuery.addEventListener('change', this.onHoverModeChange);
    this.addEventListener('keyup', this.onHoverKeyUp);
  }

  disconnectedCallback() {
    this.clearHoverTimers();
    this.hoverMenus.forEach((menu) => {
      menu.details.removeEventListener('pointerenter', menu.enter);
      menu.details.removeEventListener('pointerleave', menu.leave);
      menu.details.removeEventListener('toggle', menu.sync);
    });
    this.hoverQuery.removeEventListener('change', this.onHoverModeChange);
    this.removeEventListener('keyup', this.onHoverKeyUp);
    this.hoverMenus = [];
  }

  clearHoverTimers() {
    this.hoverMenus?.forEach((menu) => {
      clearTimeout(menu.openTimer);
      clearTimeout(menu.closeTimer);
    });
  }

  onHoverEnter(menu, event) {
    if (event.pointerType !== 'mouse' || !this.hoverQuery.matches) return;
    menu.inside = true;
    clearTimeout(menu.closeTimer);
    clearTimeout(menu.openTimer);
    menu.openTimer = setTimeout(() => {
      if (!menu.inside || !this.hoverQuery.matches || menu.details.open) return;
      if (menu.details === this.mainDetailsToggle) {
        this.closest('nav')?.querySelectorAll('header-menu').forEach((other) => {
          if (other !== this) other.close();
        });
      } else {
        const parent = menu.details.parentElement.closest('details');
        this.hoverMenus.forEach((other) => {
          if (other !== menu && other.details.parentElement.closest('details') === parent) {
            this.closeHoverMenu(other);
          }
        });
      }
      menu.details.open = true;
      menu.sync();
    }, 100);
  }

  onHoverLeave(menu, event) {
    if (event.pointerType !== 'mouse' || !this.hoverQuery.matches) return;
    menu.inside = false;
    clearTimeout(menu.openTimer);
    clearTimeout(menu.closeTimer);
    // Allow the pointer to cross the space between the heading and its panel.
    menu.closeTimer = setTimeout(() => {
      const panel = menu.summary.nextElementSibling;
      if (!menu.inside && !panel?.contains(document.activeElement)) this.closeHoverMenu(menu);
    }, 250);
  }

  closeHoverMenu(menu) {
    this.hoverMenus.forEach((child) => {
      if (!menu.details.contains(child.details)) return;
      clearTimeout(child.openTimer);
      clearTimeout(child.closeTimer);
      child.inside = false;
      child.details.open = false;
      child.sync();
    });
  }

  close() {
    this.clearHoverTimers();
    this.hoverMenus?.forEach((menu) => {
      menu.inside = false;
      menu.details.open = false;
      menu.sync();
    });
    super.close();
    this.onToggle();
  }

  onToggle() {
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', String(this.mainDetailsToggle.open));
    if (!this.header) return;
    this.header.preventHide = Boolean(this.header.querySelector('header-menu > details[open]'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
